import { render, staticRenderFns } from "./TypeMetadata.vue?vue&type=template&id=4dc4040e"
import script from "./TypeMetadata.vue?vue&type=script&lang=js"
export * from "./TypeMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports